require('./searchCountries.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { formatText } = require('core/i18n').i18n;
const { countryOptions } = require('constants/countries');
// @ components
const OKSelect = require('components/commons/OKSelect/OKSelect');

class SearchCountries extends React.Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    handleChange(item) {
        if (item.value) {
            this.props.onSelect(item.value);
        }
    }

    render () {
        const {selectedValue, label, autosize, disabled} = this.props;
        const noResultsText = formatText('transfers-noResults');
        return (
            <OKSelect
                label={label}
                className="select-search-countries"
                onChange={this.handleChange}
                options={countryOptions()}
                value={selectedValue}
                clearable={false}
                noResultsText={noResultsText}
                autosize={autosize}
                disabled={disabled}
            />
        );
    }
}

SearchCountries.propTypes = {
    onSelect: PropTypes.func,
    selectedValue: PropTypes.string,
    label: PropTypes.string,
    autosize: PropTypes.bool,
    disabled: PropTypes.bool
};

SearchCountries.defaultProps = {
    label: '',
    disabled: false
}

module.exports = SearchCountries;
